import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  summary: undefined,
  paragraphs: undefined,
  folderSummaries: undefined,
  paragraphStates: {},
};

export const readabilitySlice = createSlice({
  name: "readability",
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setSummary: (state, action) => {
      state = { ...state, summary: action.payload };
      return state;
    },
    setParagraphs: (state, action) => {
      state = { ...state, paragraphs: action.payload };
      return state;
    },
    setFolderSummaries: (state, action) => {
      state = { ...state, summary: action.folderSummaries };
      return state;
    },
    setParagraphStates: (state, action) => {
      const { rowIndex, data } = action.payload;
      if (data) {
        state = {
          ...state,
          paragraphStates: { ...state.paragraphStates, [rowIndex]: data },
        };
      } else {
        const { [rowIndex]: _, ...rest } = state.paragraphStates;
        state = { ...state, paragraphStates: { ...rest } };
      }
      return state;
    },
  },
});

export const {
  reset,
  setSummary,
  setParagraphs,
  setFolderSummaries,
  setParagraphStates,
} = readabilitySlice.actions;

export default readabilitySlice.reducer;
